
<div
  class="couleur-fond align-items-center h-100 position-relative"
  :class="typeCarte"
  :style="{ '--couleur': produit.image4Color ? produit.image4Color : '#060606' }"
>
  <b-container class="m-auto d-flex justify-content-center align-items-center h-100">
    <b-row class="m-0 pr-2 w-100 h-100 text-white justify-content-center">
      <b-col
        cols="8"
        class="graphik_bold image-banniere d-flex align-items-center justify-content-center mh-100"
      >
        <div class="h-100 w-100 text-center">
          <b-img-lazy class="mh-100 mw-100" :src="jel_getFichierSrc(produit.image4)" alt="" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</div>
